export const removeSpecificKeys = (obj, keys) => {
    Object.keys(obj).forEach(key => {
      if (keys && keys.includes(key)) delete obj[key]
      if (obj[key] === "") delete obj[key]
    });
    return obj;
}